

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import GroupDeviceItem from '@/pages/groups/GroupTabs/GroupDeviceItem.vue';

@Component({
    components: {
        GroupDeviceItem
    }
})
class DeviceVirtualList extends Vue {
    @Prop({ default: () => [] }) items;
    @Prop({ default: false }) editable;
    @Prop({ default: () => ({}) }) isChecked;
    @Prop() updateDevices;
    @Prop({ default: 120 }) rowHeight;
    @Prop({ default: 4 }) buffer;

    scrollTop = 0;
    viewportHeight = 0;
    ticking = false;
    resizeObserver: any = null;

    $refs!: { viewport: HTMLElement };

    get effectiveViewport(){
        // Fall back to a generous height until the element has been measured,
        // so we never render too few rows (which looks like "missing items").
        return this.viewportHeight > 0 ? this.viewportHeight : 800;
    }

    get totalHeight(){
        return (this.items ? this.items.length : 0) * this.rowHeight;
    }

    get visibleCount(){
        return Math.ceil(this.effectiveViewport / this.rowHeight);
    }

    get startIndex(){
        return Math.max(0, Math.floor(this.scrollTop / this.rowHeight) - this.buffer);
    }

    get endIndex(){
        const total = this.items ? this.items.length : 0;
        return Math.min(total, this.startIndex + this.visibleCount + this.buffer * 2);
    }

    get offsetY(){
        return this.startIndex * this.rowHeight;
    }

    get visibleItems(){
        if (!this.items) return [];
        return this.items.slice(this.startIndex, this.endIndex);
    }

    onScroll(){
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            if (this.$refs.viewport) {
                this.scrollTop = this.$refs.viewport.scrollTop;
                // Keep the measured height current (handles late layout/resize).
                const h = this.$refs.viewport.clientHeight;
                if (h && h !== this.viewportHeight) this.viewportHeight = h;
            }
            this.ticking = false;
        });
    }

    measure(){
        if (this.$refs.viewport) this.viewportHeight = this.$refs.viewport.clientHeight;
    }

    measureRetry(attempts = 5){
        this.measure();
        if ((!this.viewportHeight || this.viewportHeight === 0) && attempts > 0) {
            requestAnimationFrame(() => this.measureRetry(attempts - 1));
        }
    }

    @Watch('items')
    onItemsChange(){
        // Reset to top when the underlying list is replaced.
        this.scrollTop = 0;
        if (this.$refs.viewport) this.$refs.viewport.scrollTop = 0;
        this.$nextTick(() => this.measure());
    }

    mounted(){
        this.$nextTick(() => this.measureRetry());
        const RO = (window as any).ResizeObserver;
        if (typeof RO !== 'undefined') {
            this.resizeObserver = new RO(() => this.measure());
            this.resizeObserver.observe(this.$refs.viewport);
        } else {
            window.addEventListener('resize', this.measure);
        }
    }

    beforeDestroy(){
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        } else {
            window.removeEventListener('resize', this.measure);
        }
    }
}

export default DeviceVirtualList;
